import { render, staticRenderFns } from "./_DisciplinaFormAdicionar.vue?vue&type=template&id=8191a200&scoped=true"
import script from "./_DisciplinaFormAdicionar.vue?vue&type=script&lang=ts"
export * from "./_DisciplinaFormAdicionar.vue?vue&type=script&lang=ts"
import style0 from "./_DisciplinaFormAdicionar.vue?vue&type=style&index=0&id=8191a200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8191a200",
  null
  
)

export default component.exports